function getUserFirstAndLastName(userName?: string | null): { firstName: string, lastName?: string } {
  const userNameArr = (userName || '').split(' ');

  return {
    firstName: userNameArr[0],
    lastName: userNameArr[1] ? userNameArr.slice(1).join(' ') : undefined,
  };
}

export default getUserFirstAndLastName;